var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 0c5.921 0 10 3.733 10 10 0 2.991-1.654 6.29-4.313 9.439-2.125 2.517-4.615 4.592-5.687 4.592s-3.562-2.075-5.687-4.592C3.654 16.289 2 12.99 2 10 2 3.733 6.079 0 12 0zm0 2c-4.854 0-8 2.879-8 8 0 2.418 1.459 5.327 3.841 8.149.947 1.122 1.985 2.156 2.917 2.932.408.34.774.612 1.061.791.068.042.128.078.181.107.053-.03.113-.065.18-.107.288-.18.654-.451 1.062-.791.932-.776 1.97-1.81 2.917-2.932C18.541 15.327 20 12.419 20 10c0-5.121-3.146-8-8-8zm0 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapO);
export default __webpack_public_path__ + "static/media/map-o.d03bf420.svg";
export { ForwardRef as ReactComponent };